/**
 * The change history in Records: every audited change, grouped into areas
 * for filtering. An entity the list doesn't name falls into "Other".
 */
import type { AuditEntry } from "./types";

export const HISTORY_AREAS = [
  { key: "finance", label: "Finance", entities: ["lever", "commitment", "snapshot", "balance", "gate", "authority"] },
  { key: "decisions", label: "Decisions & actions", entities: ["decision", "action", "milestones", "decision_types", "consent_groups"] },
  { key: "risks", label: "Risks", entities: ["risk", "risk_register", "risk_scale", "risk_domains", "risk_tiers"] },
  { key: "obligations", label: "Obligations", entities: ["obligation", "obligation_categories", "company"] },
  { key: "releases", label: "Release log", entities: ["release", "release_frameworks", "release_reviewers"] },
  { key: "measures", label: "Measures", entities: ["measure", "measures", "measure_defs"] },
  { key: "packs", label: "Packs", entities: ["pack", "pack_sections"] },
  { key: "meetings", label: "Meetings and minutes", entities: ["meeting", "minutes"] },
  { key: "people", label: "People", entities: ["user"] },
  { key: "settings", label: "Settings and connections", entities: ["settings", "xero", "google_calendar", "google_drive", "drive"] },
] as const;
export type HistoryArea = (typeof HISTORY_AREAS)[number]["key"] | "other";

export const areaOf = (entity: string): HistoryArea => HISTORY_AREAS.find((a) => (a.entities as readonly string[]).includes(entity))?.key ?? "other";
export const AREA_LABEL: Record<HistoryArea, string> = { ...Object.fromEntries(HISTORY_AREAS.map((a) => [a.key, a.label])), other: "Other" } as Record<HistoryArea, string>;
export const KNOWN_ENTITIES: string[] = HISTORY_AREAS.flatMap((a) => [...a.entities]);

export interface HistoryPage {
  entries: AuditEntry[];
  /** Pass back as `before` for the next page; null at the end. */
  next: string | null;
}
